import { SVGInterface } from "../../interface";

const FolderUpload = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM9.41 14.42L11 12.84V17H13V12.84L14.59 14.43L16 13.01L12.01 9L8 13.01L9.41 14.42Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default FolderUpload;
